import React from 'react'
import Navbar from './Navbar'

const NFT = () => {
  return (
    <>
    <Navbar/>
    <div>
     NFT Page Comming Soon....
    </div>
    </>
  )
}

export default NFT
